import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import client from "../../api";
import { Button, Card, Input, Table } from "antd";
import GlobalContext from "src/context/global-context";
import AddIpModal from "src/components/users/CardMerchants/AddNewIPModal";

const VirtualCardsMerchantView = () => {
  const { id } = useParams();
  const { setAlertTitle, setAlertText, setIsAlertOpened } = useContext(GlobalContext);
  const [addIpModalOpen, setAddIpModalOpen] = useState(false);
  const [merchant, setMerchant] = useState<any>(null);
  const [newIp, setNewIp] = useState("");
  
  //  Get merchant details
  const { mutate: getDetails, isLoading } = useMutation(
    client.cardMerchants.viewParticularMerchant,
    {
      onSuccess: (res: any) => {
        if(res?.code === 500){
          setAlertTitle("error")
          setAlertText(res?.message);
          setIsAlertOpened(true);
        }
        setMerchant(res?.data?.data);
      },
      onError: (error: any) => {
        setAlertText("Failed to fetch merchant");
        setIsAlertOpened(true);
      },
    },
  );

  // 🔹 Create API Key
  const { mutate: createApiKey, isLoading: isLoadingCreateApiKey } =
    useMutation(client.cardMerchants.createCardMerchantApiKey, {
      onSuccess: () => getDetails({ merchant_id: id }),
    });

  // 🔹 Revoke API Key
  const { mutate: revokeApiKey,isLoading: isLoadingRevokeApiKey } = useMutation(
    client.cardMerchants.revokeCardMerchantApiKey,
    {
      onSuccess: () => getDetails({ merchant_id: id }),
    },
  );

  // 🔹 Add IP
  const { mutate: addIp, isLoading: addIpLoading } = useMutation(
    client.cardMerchants.addCardMerchantIpAddresses,
    {
      onSuccess: () => {
        setNewIp("");
        getDetails({ merchant_id: id });
        setAddIpModalOpen(false);
      },
    },
  );

  const handleAddIp = (data: { ip_address: string; description: string }) => {
    addIp({
      merchant_id: id,
      ip_address: data.ip_address,
      description: data.description,
    });
  };

  const apiKeyColumns = [
    {
      title: "API Key",
      dataIndex: "api_key",
      render: (val: string) => <span className="font-medium">{val}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Action",
      render: (_: any, record: any) => (
        <Button
        disabled={isLoadingRevokeApiKey || record?.status==="revoked"}
          danger
          size="small"
          onClick={() => revokeApiKey({ api_key_id: record.id })}
        >
          Revoke
        </Button>
      ),
    },
  ];

  const ipColumns = [
    {
      title: "IP Address",
      dataIndex: "ip_address",
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (val: string) => val || "-",
    },
  ];

  useEffect(() => {
    if (id) getDetails({ merchant_id: id });
  }, [id]);

  if (isLoading ) return <p>Loading...</p>;

  return (
    <div className="p-6 flex flex-col gap-6">
      {/* ✅ 1. Merchant Details */}
      <Card title="Merchant Details">
        <div className="grid grid-cols-2 gap-4">
          <p>
            <b>ID:</b> {merchant?.id}
          </p>
          <p>
            <b>Name:</b> {merchant?.name}
          </p>
          <p>
            <b>Environment:</b> {merchant?.environment}
          </p>
          <p>
            <b>Status:</b>{" "}
            <span
              className={`px-2 py-1 rounded text-white ${
                merchant?.status === "active" ? "bg-green-500" : "bg-gray-400"
              }`}
            >
              {merchant?.status}
            </span>
          </p>
        </div>
      </Card>

      {/* ✅ 2. API Keys */}
      <Card
        title="API Keys"
        extra={
          merchant?.api_keys?.length == 0 && (
            <Button
              loading={isLoadingCreateApiKey}
              onClick={() => createApiKey({ merchant_id: id })}
            >
              Create API Key
            </Button>
          )
        }
      >
        <Table
          rowKey="id"
          columns={apiKeyColumns}
          dataSource={merchant?.api_keys || []}
          pagination={false}
        />
      </Card>

      {/* ✅ 3. IP Whitelist */}
      <Card
        title="IP Whitelist"
        extra={<Button onClick={() => setAddIpModalOpen(true)}>Add IP</Button>}
      >
        <Table
          rowKey="id"
          columns={ipColumns}
          dataSource={merchant?.ip_whitelist || []}
          pagination={false}
        />
      </Card>
      <AddIpModal
        open={addIpModalOpen}
        onClose={() => setAddIpModalOpen(false)}
        onSubmit={handleAddIp}
        loading={addIpLoading}
      />
    </div>
  );
};

export default VirtualCardsMerchantView;
